module.exports = __webpack_public_path__ + "static/img/weekly_weather_non_member.fc7c543c.png";